<!-- Copyright 2023 Midas Healthcare Solutions - All Rights Reserved -->
<button
  mat-icon-button
  *ngIf="theme$ | async as theme"
  [matTooltip]="theme === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'"
  (click)="setTheme(theme)"
>
  <mat-icon>{{ theme === 'dark' ? 'light_mode' : 'dark_mode_outline' }}</mat-icon>
</button>
